'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeCalendarIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeCalendarIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C10.7578 0 11.4845 0.30102 12.0203 0.836838C12.5561 1.37266 12.8571 2.09938 12.8571 2.85714V5.71429H27.1429V2.85714C27.1429 2.09938 27.4439 1.37266 27.9797 0.836838C28.5155 0.30102 29.2422 0 30 0C30.7578 0 31.4845 0.30102 32.0203 0.836838C32.5561 1.37266 32.8571 2.09938 32.8571 2.85714V5.71429H35.7143C36.2771 5.71429 36.8344 5.82514 37.3544 6.04052C37.8743 6.25589 38.3468 6.57158 38.7447 6.96954C39.1427 7.36751 39.4584 7.83996 39.6738 8.35993C39.8891 8.87989 40 9.43719 40 10V12.8571H0V10C0 9.43719 0.110853 8.87989 0.326231 8.35993C0.541608 7.83996 0.857291 7.36751 1.25526 6.96954C2.05898 6.16581 3.14907 5.71429 4.28571 5.71429H7.14286V2.85714C7.14286 2.09938 7.44388 1.37266 7.97969 0.836838C8.51551 0.30102 9.24224 0 10 0Z"
          fill="#3D517B"
        />
        <path
          d="M0 12.8574H40V35.7146C40 36.2774 39.8891 36.8347 39.6738 37.3546C39.4584 37.8746 39.1427 38.3471 38.7447 38.745C38.3468 39.143 37.8743 39.4587 37.3544 39.6741C36.8344 39.8894 36.2771 40.0003 35.7143 40.0003H4.28571C3.72291 40.0003 3.16561 39.8894 2.64564 39.6741C2.12568 39.4587 1.65322 39.143 1.25526 38.745C0.857291 38.3471 0.541608 37.8746 0.326231 37.3546C0.110853 36.8347 0 36.2774 0 35.7146L0 12.8574Z"
          fill="#D8DCE5"
        />
      </svg>
    </SvgIcon>
  )
}

LargeCalendarIcon.propTypes = {
  sx: PropTypes.object
}
